import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import Authentication from "@/components/Authentication";
import Experiments from "@/components/Experiments";

Vue.use(VueRouter);

const skipIfAuthenticated = async (to, from, next) => {
  if (!store.state.account.current) await store.dispatch("account/current");
  return store.state.account.current ? next({ name: "Account" }) : next();
};

const requiresAuthentication = async (to, from, next) => {
  if (!store.state.account.current) await store.dispatch("account/current");
  return store.state.account.current
    ? next()
    : next({ name: "Authentication" });
};

const routes = [
  {
    path: "/",
    name: "Authentication",
    component: Authentication,
    beforeEnter: skipIfAuthenticated
  },
  {
    path: "/experiments",
    name: "Account",
    component: Experiments,
    beforeEnter: requiresAuthentication
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
